import { Button, Select, Table, Typography, Image } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useState } from "react";
import "../BNPLModal/BNPLModal.scss";
import InfoIcon from "../../../../assets/Icons/infoIcon.svg";
import Cookies from "js-cookie";

const BNPLComponent = ({
  AddToCartModal,
  addProduct,
  hideAboveSection,
  AllBankPlans,
  BAFLCardPlans,
  setInstallmentModalVisible,
  SelectedPlan,
  SelectedBank,
  interestRate,
  setInterestRate,
}) => {
  const Text = Typography;
  const { Option } = Select;

  const [selectedBAFLPlan, setSelectedBAFLPlan] = useState(
    SelectedBank === "bafl_plans" ? SelectedPlan : null
  );
  const [selectedAllBankPlan, setSelectedAllBankPlan] = useState(
    SelectedBank === "all_bank_plans" ? SelectedPlan : null
  );
  const mainColor = Cookies.get("main_theme");
  const secondaryColor = Cookies.get("secondary_theme");

  const normalizeInterestRate = (raw) => {
    if (raw == null) return undefined;
    if (typeof raw === "number" && !Number.isNaN(raw)) return raw;
    if (
      typeof raw === "object" &&
      raw !== null &&
      typeof raw.interest_rate === "number"
    ) {
      return raw.interest_rate;
    }
    const n = Number(raw);
    return Number.isFinite(n) ? n : undefined;
  };
  // const handleBAFLPlanChange = (value) => {
  //   setSelectedBAFLPlan(value);
  //   setSelectedAllBankPlan(null);

  // };

  const handleBAFLPlanChange = (value) => {
    setSelectedBAFLPlan(value);
    setSelectedAllBankPlan(null);

    const selectedPlanObj = BAFLCardPlans?.plans?.find(
      (plan) => plan.installment_plan === value
    );

    if (selectedPlanObj && setInterestRate) {
      setInterestRate(normalizeInterestRate(selectedPlanObj.interest_rate));
    }
  };

  const handleAllBankPlanChange = (value) => {
    setSelectedAllBankPlan(value);
    setSelectedBAFLPlan(null);
  };
  const addonElements = document.getElementsByClassName(
    "ant-input-number-group-addon"
  );

  Array.from(addonElements).forEach((element) => {
    element.style.backgroundColor = mainColor;
  });

  // const BAFLCardPlanOptions = BAFLCardPlans?.plans.map((plan, index) => (
  //   <Option key={`bafl-plan-${index}`} value={plan}>
  //     {plan}
  //   </Option>
  // ));
  const BAFLCardPlanOptions = BAFLCardPlans?.plans.map((plan, index) => (
    <Option key={`bafl-plan-${index}`} value={plan.installment_plan}>
      {plan.installment_plan}
    </Option>
  ));

  const AllBankPlanOptions = AllBankPlans?.plans.map((plan, index) => (
    <Option key={`allbank-plan-${index}`} value={plan.value}>
      {plan.label}
    </Option>
  ));

  // const dataBAFL = BAFLCardPlans?.processing_fees?.map((feeInfo, index) => ({
  //   key: index,
  //   plan: feeInfo.plan,
  //   fee: feeInfo.fees,
  // }));

  const dataBAFL = BAFLCardPlans?.processing_fees?.map((feeInfo, index) => {
    const monthsMatch = feeInfo.plan.match(/(\d+)\s*Months?/i);
    const months = monthsMatch ? parseInt(monthsMatch[1]) : null;

    const correspondingPlan = BAFLCardPlans?.plans?.find(
      (plan) => plan.months === months
    );

    return {
      key: index,
      plan: feeInfo.plan,
      fee: feeInfo.fees,
      installment_price: feeInfo.installment_price || "N/A",
      interest_rate: correspondingPlan?.interest_rate ?? null,
    };
  });

  const dataABCC = AllBankPlans?.processing_fees?.map((feeInfo, index) => {
    // Find corresponding plan_details for this tenure
    const planDetail = AllBankPlans?.plan_details?.find(
      (detail) => detail.tenure === feeInfo.plan
    );

    return {
      key: index,
      plan: feeInfo.plan,
      fee: feeInfo.fees,
      installment_price: planDetail?.installment_fee || "N/A",
    };
  });

  // const columns = [
  //   {
  //     title: "Installment Plans",
  //     dataIndex: "plan",
  //     key: "plan",
  //     align: "center",
  //     className: "table-header",
  //   },
  //   {
  //     title: "Processing Fees + FED (One Time)",
  //     dataIndex: "fee",
  //     key: "fee",
  //     align: "center",
  //     className: "table-header",
  //   },
  // ];

  const columns = [
    {
      title: "Installment Plans",
      dataIndex: "plan",
      key: "plan",
      align: "center",
      className: "table-header",
      render: (text, record) => (
        <span>
          {text}
          {record.interest_rate === 0 && " (0% Markup)"}
        </span>
      ),
      onCell: (record) => ({
        style: {
          backgroundColor: record.interest_rate === 0 ? "#D62314" : "white",
          color: record.interest_rate === 0 ? "white" : "black",
        },
      }),
    },
    {
      title: "Processing Fees + FED (One Time)",
      dataIndex: "fee",
      key: "fee",
      align: "center",
      className: "table-header",
      render: (text) => (
        <span style={{ color: "red", fontWeight: "500" }}>{text}</span>
      ),
    },
    {
      title: "Installment Price",
      dataIndex: "installment_price",
      key: "installment_price",
      align: "center",
      className: "table-header",
      render: (text) => <span style={{ fontWeight: "500" }}>PKR {text}</span>,
    },
  ];

  // const handleCheckout = () => {
  //   if (selectedBAFLPlan) {
  //     addProduct(selectedBAFLPlan, { is_bnpl: true, is_bafl_plan: true });
  //   } else if (selectedAllBankPlan) {
  //     addProduct(selectedAllBankPlan, { is_bnpl: true, is_bafl_plan: false });
  //   }
  // };

  const handleCheckout = () => {
    if (selectedBAFLPlan) {
      const selectedPlanObj = BAFLCardPlans?.plans?.find(
        (plan) => plan.installment_plan === selectedBAFLPlan
      );
      addProduct(selectedBAFLPlan, {
        is_bnpl: true,
        is_bafl_plan: true,
        interest_rate: normalizeInterestRate(selectedPlanObj?.interest_rate),
      });
      if (setInterestRate) {
        setInterestRate(normalizeInterestRate(selectedPlanObj?.interest_rate));
      }
    } else if (selectedAllBankPlan) {
      const selectedPlanObj = AllBankPlans?.plans?.find(
        (plan) =>
          (typeof plan === "object" && plan?.value === selectedAllBankPlan) ||
          plan === selectedAllBankPlan
      );
      addProduct(selectedAllBankPlan, {
        is_bnpl: true,
        is_bafl_plan: false,
        interest_rate: normalizeInterestRate(selectedPlanObj?.interest_rate),
      });
    }
  };

  return (
    <div className="bnpl-component-container">
      {dataBAFL?.length > 0 ? (
        <>
          <h2 style={{ textAlign: "center", fontWeight: "bold" }}>
            Bank Alfalah
          </h2>
          <Select
            value={selectedBAFLPlan || "Select Installment Plan"}
            onChange={handleBAFLPlanChange}
            dropdownClassName="custom-dropdown"
            style={{
              width: "100%",
              marginBottom: "10px",
              borderRadius: "5px",
              border: "none",
            }}
          >
            {BAFLCardPlanOptions}
          </Select>

          {/* {selectedBAFLPlan && (
            <Text
              className="font20Bold marginBottom10"
              style={{ textAlign: "left" }}
            >
              <span style={{ color: "black" }}>As Low as : </span>
              <span style={{ color: mainColor }}>
                {selectedBAFLPlan.split("Months |")[1]?.trim()}
              </span>
            </Text>
          )} */}

          <Table
            columns={columns}
            dataSource={dataBAFL}
            pagination={false}
            style={{
              marginBottom: "20px",
              border: "1px solid rgb(235, 235, 235)",
              borderRadius: "5px",
            }}
          />
        </>
      ) : null}
      {/* <h2 style={{ textAlign: "center" }}>All Bank’s Credit Cards</h2>
      <Select
        value={selectedAllBankPlan || "Select Installment Plan"}
        onChange={handleAllBankPlanChange}
        dropdownClassName="custom-dropdown"
        style={{
          width: "100%",
          marginBottom: "10px",
          borderRadius: "5px",
          border: "none",
        }}
      >
        {AllBankPlanOptions}
      </Select>

      {selectedAllBankPlan && (
        <Text
          className="font20Bold marginBottom10"
          style={{ textAlign: "left" }}
        >
          <span style={{ color: "black" }}>As Low as : </span>
          <span style={{ color: mainColor }}>
            {selectedAllBankPlan.split("Months |")[1]?.trim()}
          </span>
        </Text>
      )}

      {dataABCC?.length > 0 && (
        <Table
          columns={columns}
          dataSource={dataABCC}
          pagination={false}
          style={{
            marginBottom: "20px",
            border: "1px solid rgb(235, 235, 235)",
            borderRadius: "5px",
          }}
        />
      )} */}

      {/* Only render All Banks section if plans exist and have length */}
      {AllBankPlans?.plans && AllBankPlans.plans.length > 0 ? (
        <>
          <h2 style={{ textAlign: "center" }}>All Banks, Credit Cards</h2>
          <Select
            value={selectedAllBankPlan || "Select Installment Plan"}
            onChange={handleAllBankPlanChange}
            dropdownClassName="custom-dropdown"
            style={{
              width: "100%",
              marginBottom: "10px",
              borderRadius: "5px",
              border: "none",
            }}
          >
            {AllBankPlanOptions}
          </Select>

          {selectedAllBankPlan && (
            <Text
              className="font20Bold marginBottom10"
              style={{ textAlign: "left" }}
            >
              <span style={{ color: "black" }}>As Low as : </span>
              <span style={{ color: mainColor }}>
                {typeof selectedAllBankPlan === "string" 
                  ? selectedAllBankPlan.split("Months |")[1]?.trim()
                  : selectedAllBankPlan?.value?.split("Months |")[1]?.trim()}
              </span>
            </Text>
          )}

          {dataABCC?.length > 0 && (
            <Table
              columns={columns}
              dataSource={dataABCC}
              pagination={false}
              style={{
                marginBottom: "20px",
                border: "1px solid rgb(235, 235, 235)",
                borderRadius: "5px",
              }}
            />
          )}
        </>
      ) : null}

      <Text
        className="font12Bold bnpl-helper-text-container"
        style={{ textAlign: "left", marginBottom: "20px" }}
      >
        <span className="marginRight5">
          <Image
            height={20}
            src={InfoIcon.src}
            preview={false}
            alt="info-icon"
          />
        </span>
        <p className="bnpl-helper-text font12Bold" style={{ marginTop: "2px" }}>
          All Bank's Credit Cards on 0% processing fees on all tenors
          <br />
          <span className="font12">
            {" "}
            Maximum Limit of up to 750K based on eligibility criteria
          </span>
        </p>
      </Text>

      <Button
        onClick={handleCheckout}
        type="primary"
        size="large"
        disabled={!selectedBAFLPlan && !selectedAllBankPlan}
        style={{
          width: "200px",
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          // padding: "8px 0px 30px 0px",
          borderRadius: "15px",
        }}
      >
        {AddToCartModal ? "Add To Cart" : "Apply Changes"}
      </Button>
    </div>
  );
};

export default BNPLComponent;
